import { gql, useQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import * as React from 'react';

import { Loading } from '@/imports/ui/chakra/components/Loading';

import {
  QuestionPage_GetPostByQuestionId,
  QuestionPage_GetPostByQuestionIdVariables,
} from './graphql-types/QuestionPage_GetPostByQuestionId';

const POST_QUERY = gql`
  query QuestionPage_GetPostByQuestionId($input: GetPostBySubPostIdInput!) {
    getPostIdBySubPostId(input: $input) {
      result {
        _id
      }
    }
  }
`;

// TODO: this should be a next js middleware

export const QuestionPage: React.FC = () => {
  const router = useRouter();
  const { questionId } = router.query;

  const { data, loading } = useQuery<
    QuestionPage_GetPostByQuestionId,
    QuestionPage_GetPostByQuestionIdVariables
  >(POST_QUERY, {
    variables: { input: { questionId: questionId.toString() } },
  });

  const postId = data?.getPostIdBySubPostId.result?._id;

  React.useEffect(() => {
    if (router.isReady) {
      if (postId) {
        router.replace({
          pathname: `/community/post/${postId}`,
          query: router.query,
        });
      }
    }
  }, [postId, router]);

  if (loading) {
    return <Loading />;
  }

  return null;
};
